import { orchestrator } from 'satcheljs';
import { preloadAppsForFiles, preloadApps } from '../actions/internalActions';
import {
    getExtensionFromFileName,
    getOfficeOnlineAppFromExtension,
    OfficeOnlineApp,
} from 'owa-file';

orchestrator(preloadAppsForFiles, ({ fileNames }) => {
    const appsToInitialize = fileNames.reduce<Partial<Record<OfficeOnlineApp, true>>>(
        (apps, fileName) => {
            const extension = getExtensionFromFileName(fileName);
            const officeApp = getOfficeOnlineAppFromExtension(extension);

            if (officeApp !== null && officeApp !== undefined) {
                apps[officeApp] = true;
            }

            return apps;
        },
        {}
    );

    const appsListToPreload: OfficeOnlineApp[] = Object.keys(appsToInitialize) as any[];
    preloadApps(appsListToPreload);
});
